import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import {
  CCreateElement,
  CSidebar,
  CSidebarBrand,
  CSidebarNav,
  CSidebarNavDivider,
  CSidebarNavTitle,
  CSidebarMinimizer,
  CSidebarNavDropdown,
  CSidebarNavItem,
} from '@coreui/react'

import CIcon from '@coreui/icons-react'
import { useAuth } from '../context/auth';

// sidebar nav config
import navigation from './_nav'
import navigationSysMenu from './_navSysMenu'
import logoAlpha from '../assets/icons/7.png'
import { REACT_APP_API_BACKEND } from '../data/data';

const TheSidebar = () => {
  const dispatch = useDispatch()
  const show = useSelector(state => state.sidebarShow)
  const [navigationState, setNavigationState] = useState();
  const { userAuth } = useAuth();
  const [, setState] = React.useState(false);

  const forceReactMemoRerender = () => setState(x => !x);

useEffect(() => {
  let isMounted = true; // flag para checar se o componente ainda está montado

  // só executa se userAuth existir
  if (userAuth && (navigationSysMenu.length === 2 || userAuth.reloadMenu === true)) {
    const updatedMenu = [...navigationSysMenu]; // cria uma cópia para não mutar direto

    fetch(`${REACT_APP_API_BACKEND}/user/menus?userID=${userAuth.userID}&clientID=${userAuth.clientID}`, userAuth.accessToken)
      .then(res => res.json())
      .then(menus => {
        if (!isMounted) return; // não atualiza estado se desmontado

        if (menus.length > 0) {
          const newMenus = menus.map(menu => {
            const children = menu.parentMenus.map(parent => ({
              name: parent.name,
              to: parent.route,
              _tag: 'CSidebarNavItem'
            }));

            return {
              ...menu,
              name: menu.name,
              to: menu.route,
              _tag: 'CSidebarNavDropdown',
              icon: 'cil-cursor',
              _children: children
            };
          });

          setNavigationState([...updatedMenu, ...newMenus]); // atualiza estado com nova cópia
        } else {
          setNavigationState(navigation); // fallback
        }
      })
      .catch(err => {
        console.error("Erro ao carregar menus:", err);
        if (isMounted) setNavigationState(navigation);
      });
  }

  return () => {
    isMounted = false; // cleanup para prevenir setState em componente desmontado
  };
}, [userAuth?.clientID, userAuth?.reloadMenu]);


  return (
    <CSidebar
      show={show}
      onShowChange={(val) => dispatch({ type: 'set', sidebarShow: val })}
    >
      <CSidebarBrand className="d-md-down-none" to="/">
        {/* <CIcon
          className="c-sidebar-brand-full"
          name="logo-negative"
          height={35}
        />
        <CIcon
          className="c-sidebar-brand-minimized"
          name="sygnet"
          height={35}
        /> */}
        <img style={{ height: 30 }} src={logoAlpha} />
        {/* <label style={{ paddingLeft:7, paddingTop: 7, fontSize: 18, fontStyle: 'italic' }} className="c-sidebar-brand-full">Alpha Manager</label> */}
      </CSidebarBrand>
      <CSidebarNav>
        {navigationState &&
          <CCreateElement
            items={navigationState}
            components={{
              CSidebarNavDivider,
              CSidebarNavDropdown,
              CSidebarNavItem,
              CSidebarNavTitle
            }}
          />
        }
      </CSidebarNav>
      <CSidebarMinimizer className="c-d-md-down-none" />
    </CSidebar>
  )
}

export default React.memo(TheSidebar)
